var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrossIcon = function SvgCrossIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.575 4.434a.881.881 0 0 0-1.248 0L10 8.752 5.673 4.426a.881.881 0 1 0-1.247 1.247L8.753 10l-4.327 4.327a.881.881 0 1 0 1.247 1.248L10 11.248l4.327 4.327a.881.881 0 1 0 1.248-1.248L11.248 10l4.327-4.327a.887.887 0 0 0 0-1.239Z",
    fill: "#8F8F9B"
  })));
};
export default SvgCrossIcon;